import axios from "axios";
import { Apis } from "constants/apis";

const subscribeNewsLetter = async (payload: { email: string }) => {
    const { data } = await axios.post(Apis.SUBSCRIBE_NEWSLETTER, payload);
    return data
}

export default subscribeNewsLetter;